import type {ReactElement} from "react";
import {Chip, type ChipProps} from "@mui/material";
import VerifiedIcon from '~/icons/svg/VerifiedIcon.svg?react'
import ScheduleIcon from '~/icons/svg/ScheduleIcon.svg?react'
import WarningCircleIcon from '~/icons/svg/WarningCircleIcon.svg?react'
import InfoIcon from '~/icons/svg/InfoIcon.svg?react'
import type {BuComplianceStatus} from "~/pages/supplier-360/types/Supplier360Types";
import {BU_STATUS_LABEL} from "~/pages/supplier-360/tabs/SupplierCompliance/constants/complianceLabels";

const ICON_SIZE = {width: 14, height: 14};

/**
 * `BU_STATUS_CHIP[bu_qualification.status]` — a business unit's compliance status (§2.7) with the
 * design's tones and icons (`SXB_STATUS_TONE` / `SXB_STATUS_ICON`).
 */
export const BU_STATUS_CHIP: Record<BuComplianceStatus, ReactElement<ChipProps>> = {
    compliant: <Chip size="small" color="success" label={BU_STATUS_LABEL.compliant} icon={<VerifiedIcon {...ICON_SIZE}/>}/>,
    expiring_soon: <Chip size="small" color="warning" label={BU_STATUS_LABEL.expiring_soon} icon={<ScheduleIcon {...ICON_SIZE}/>}/>,
    non_compliant: <Chip size="small" color="error" label={BU_STATUS_LABEL.non_compliant} icon={<WarningCircleIcon {...ICON_SIZE}/>}/>,
    pending_review: <Chip size="small" color="info" label={BU_STATUS_LABEL.pending_review} icon={<InfoIcon {...ICON_SIZE}/>}/>,
};
